import clsx from "clsx";
import PropTypes from "prop-types";
import { Modal as SemanticModal } from "semantic-ui-react";
import "./modal-actions.scss";

export const ModalActions = ({ className = "", ...props }) => (
  <SemanticModal.Actions
    {...props}
    className={clsx("ha-modal-actions", className)}
  />
);

ModalActions.propTypes = {
  className: PropTypes.string,
};
